import Vue from 'vue'
const Regex = {
    phone: (el) => {
        el.maxLength = 11;
        el.oninput = () => {
            if (el.value.length == 1) {
                el.value = el.value.replace(/[^1]/g, '1')
            } else {
                el.value = el.value.replace(/[^\d]/g, '')
            }
        }
    },
    code: (el) => {
        el.maxLength = 4;
        el.oninput = () => {
            el.value = el.value.replace(/[^\d]/g, '');
        }
    },
    num: (el) => { //数字
        el.oninput = () => {
            el.value = el.value.replace(/[^\d]/g, '');
        }
        el.dispatchEvent(new Event('input'))
    },
    num_0: (el) => { //数字
        el.oninput = () => {
            el.value = el.value.replace(/[^\d]/g, '');
            if (el.value == 0 && el.value != '') {
                el.value = 1;
            }
        }
        el.dispatchEvent(new Event('input'))
    },
    num_1: (el) => { //小数1位+
        el.oninput = () => {
            el.value = el.value.replace(/^\D*(\d*(?:\.\d{0,1})?).*$/g, '$1');
        }
    },
    num_2: (el) => { //小数2位
        el.oninput = () => {
            el.value = el.value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');

        }
    },
    num_3: (el) => { //小数3位
        el.oninput = () => {
            el.value = el.value.replace(/^\D*(\d*(?:\.\d{0,3})?).*$/g, '$1');
        }
    },
    num_l: (el, binding) => { //小数3位
        let min = binding.value.min ? binding.value.min : 0;
        let max = binding.value.max ? binding.value.max : 0;
        el.oninput = () => {
            el.value = el.value.replace(/[^\d]/g, '');
        }
        el.onblur = () => {
            if (el.value == '') {
                el.value = min;
            }
            if (el.value < min) {
                el.value = min;
            }
            if (el.value > max) {
                el.value = max;
            }
            el.dispatchEvent(new Event('input'))
        }
    },

}
export default () => {
    Vue.directive('yzn', {
        update: (el, binding, vnode) => {
            el.dispatchEvent(new Event('input'))
            Regex[binding.arg](el, binding, vnode);
        }
    })
}


// WEBPACK FOOTER //
// ./src/assets/js/directives.js